import find from '../lodashUtils/find'
import get from '../lodashUtils/get'

export function getExpiryRecord(value) {
	const expiryPeriod = 90 * 24 * 60 * 60 * 1000 // 90 day expiry in milliseconds

	const expiryDate = new Date().getTime() + expiryPeriod
	return {
		value: value,
		expiryDate: expiryDate,
	}
}

export function checkIfLeadSourceDataAlreadyCaptured() {
	return !!(sessionStorage && sessionStorage.getItem('leadSource'))
}

export function storeLSData(lsd, device) {
	if (!checkIfLeadSourceDataAlreadyCaptured() && sessionStorage) {
		const lead_data = {
			url: '',
			deviceType: '',
			keyword: '',
			campaign: '',
		}
		lead_data.url = lsd.url
		lead_data.deviceType = device

		console.log('Initilizing leadSource: ', lead_data)

		sessionStorage.setItem('leadSource', JSON.stringify(lead_data))
	}
}

export function getDeviceType() {
	const w = window.innerWidth
	if (w < 768) {
		return 'Mobile'
	} else if (w >= 768 && w <= 1024) {
		return 'Tablet'
	} else {
		return 'Desktop'
	}
}

export function identifyLeadSource() {
	const ls = {
		url: '',
		deviceType: '',
		prodType: '',
	}

	ls.url = document.referrer
	storeLSData(ls, getDeviceType())
}

export function setLeadSourceParams(
	query = {},
	reset = false,
	newLeadSourceData = {},
) {
	let leadSourceData = reset
		? {}
		: JSON.parse(sessionStorage.getItem('leadSource'))
	leadSourceData = {
		...leadSourceData,
		...newLeadSourceData,
		...query,
	}

	if (reset) {
		leadSourceData.url = document.referrer
		leadSourceData.deviceType = getDeviceType()
	}

	if (leadSourceData.searchKeyWords && !leadSourceData.keyword) {
		leadSourceData.keyword = leadSourceData.searchKeyWords
	}
	//delete leadSourceData.searchKeyWords; // Will add this code again after releasing lead-attribution in plato
	/**
	 * added till the time it lead attribution is released in plato
	 */
	if (!leadSourceData.searchKeyWords && leadSourceData.keyword) {
		leadSourceData.searchKeyWords = leadSourceData.keyword
	}

	console.log('Resetting leadSource: ', leadSourceData)

	sessionStorage.setItem('leadSource', JSON.stringify(leadSourceData))
}

export function updateItinerarySourcePage(source) {
	let itineraryCreatedSourceLocal =
		sessionStorage && sessionStorage.getItem('itineraryCreatedSource')

	if (!itineraryCreatedSourceLocal) {
		itineraryCreatedSourceLocal = []
	} else {
		itineraryCreatedSourceLocal = JSON.parse(itineraryCreatedSourceLocal)
	}

	itineraryCreatedSourceLocal.push(source)
	if (source) {
		sessionStorage.setItem(
			'itineraryCreatedSource',
			JSON.stringify(itineraryCreatedSourceLocal),
		)
	}
}

/**
 * @author Jothisankar <jothi@pickyourtrail.com>
 * @param history
 * @param lastLocation
 * @param itineraryId
 * @description Will be served as global method to fetch/create leadSource object for lead/user tracking.
 */
export function getLeadSource({
	router = {},
	lastLocation = {},
	itineraryId = '',
	isCBR = false,
	version,
	...rest
}) {
	let leadSource = { ...rest }
	let isMaldivesSlugRoute
	if (checkIfLeadSourceDataAlreadyCaptured() && sessionStorage) {
		leadSource = {
			...leadSource,
			...JSON.parse(sessionStorage.getItem('leadSource')),
		}

		// IP-INFO
		const ipInfo = JSON.parse(localStorage.getItem('user-ip-info')) || {}
		leadSource = { ...leadSource, ipInfo }

		// CPID
		leadSource.cpid = sessionStorage.getItem('campaignId')
		leadSource.landingPage = sessionStorage.getItem('source')

		// Chat bot actions
		const triggeredCBRFromChat =
			sessionStorage.getItem('triggeredCBRFromChat') || false
		const triggeredGCMFromChat =
			sessionStorage.getItem('triggeredGCMFromChat') || false

		if (lastLocation) {
			leadSource.lastRoute = get(lastLocation, 'pathname', '')
			// isMaldivesSlugRoute =
			//   (lastLocation.pathname || '').indexOf(
			//     MALDIVES_ROUTES.LANDING_PAGE_KEY
			//   ) == 0 ||
			//   (lastLocation.pathname || '').indexOf(
			//     MALDIVES_ROUTES.MALDIVES_SLUG_KEY
			//   ) > -1;
		}

		const pathName = router.asPath.split('?')[0]
		const pathNameArr = pathName.split('/')

		if (version === 'SPEEDBOAT') {
			leadSource.prodType = 'speedboat'
		} else if (
			pathNameArr[1].indexOf('vacations') >= 0 ||
			pathName.indexOf('packages') > 0
		) {
			// Adding condition to differentiate CBR with GCM - default value for this false
			leadSource.prodType = isCBR
				? triggeredCBRFromChat
					? 'PKG_CHAT_CBR'
					: window.location.href.split('/').includes('request-whatsapp-chat')
					? 'WA'
					: 'CBR'
				: pathNameArr[1].indexOf('vacations') >= 0
				? 'VACATIONS'
				: triggeredGCMFromChat
				? 'PKG_CHAT_GCM'
				: 'PACKAGES'

			// if (history.location.search.indexOf('&autocbr') > 0) {
			//   leadSource.prodType = 'EXIT_INTENT_CBR';
			// }
		} else if (
			window.location.href.split('/request-callback')[0] ===
			window.location.origin
		) {
			leadSource.prodType = 'CBR'
		} else if (
			window.location.href.split('/').includes('request-whatsapp-chat')
		) {
			leadSource.prodType = 'WA'
		} else if (pathName.indexOf('/customize/') >= 0 || isMaldivesSlugRoute) {
			leadSource.prodType = triggeredCBRFromChat
				? 'PDG_CHAT_CBR'
				: triggeredGCMFromChat
				? 'PDG_CHAT_GCM'
				: isCBR
				? 'CBR'
				: 'PDG'
			// } else if (isCredDeals()) {
			//   leadSource.prodType = 'CRED';
			// } else if (isPytDeals()) {
			//   leadSource.prodType = 'deals';
		} else if (pathNameArr?.includes('cruise')) {
			leadSource.prodType = 'CRUISE'
		} else if (version === 'STAYCATION') {
			leadSource.prodType = 'sc_deals'
		} else if (pathName.indexOf('/dubai/') >= 0) {
			leadSource.prodType = 'SANDUNE'
		} else if (pathName.indexOf('/sankash') >= 0) {
			leadSource.prodType = 'SANKASH'
		} else {
			let itineraryCreatedSourceLocal = sessionStorage.getItem(
				'itineraryCreatedSource',
			)

			if (itineraryCreatedSourceLocal) {
				const itinerarySourceObj = JSON.parse(itineraryCreatedSourceLocal)

				const current_itin_obj = find(itinerarySourceObj, function (obj) {
					return obj && obj.itineraryId === itineraryId
				})

				if (current_itin_obj) {
					leadSource.prodType = current_itin_obj.page
				}
			}
			if (!leadSource.prodType || leadSource.prodType === '') {
				leadSource.prodType = 'PDG' // UPDATING DEFAULT PROD_TYPE TO PDG FROM RECENTLY_BOOKED
			}
		}
	}

	leadSource = { ...leadSource, ...router.query }
	if (leadSource.searchKeyWords && !leadSource.keyword) {
		leadSource.keyword = leadSource.searchKeyWords
	}
	//delete leadSource.searchKeyWords;  // Will add this code again after releasing lead-attribution in plato

	/**
	 * added till the time it lead attribution is released in plato
	 */
	if (!leadSource.searchKeyWords && leadSource.keyword) {
		leadSource.searchKeyWords = leadSource.keyword
	}

	if (!leadSource.url && sessionStorage) {
		leadSource.url = sessionStorage.getItem('source')
	}

	if (leadSource.cpid && leadSource.cpid.toLowerCase() === 'mobile-app') {
		leadSource.prodType = 'mobile-app'
	}

	// Google click id for paid leads
	const gclid =
		localStorage.getItem('gclid') &&
		JSON.parse(localStorage.getItem('gclid') || '')
	const isGclidValid = gclid && new Date().getTime() < gclid.expiryDate

	if (isGclidValid) {
		leadSource.gclid = gclid.value
	}

	//ensured deviceType goes in all calls
	leadSource.deviceType = getDeviceType()

	return leadSource
}
